module.exports = __webpack_public_path__ + "static/media/User-fc.da3082a2.svg";